import { compose, withHandlers, withPropsOnChange, branch } from "recompact"
import { connect } from "react-redux"
import queryString from "query-string"
import { submit } from "redux-form"
import uuid4 from "uuid/v4"
import warning from "warning"
import cloneDeep from "lodash/cloneDeep"
import isString from "lodash/isString"
import isObjectLike from "lodash/isObjectLike"
import identity from "lodash/identity"
import isFunction from "lodash/isFunction"
import get from "lodash/get"
import {
  selectPlanTagsAvailable,
  selectStatusAvailable,
} from "src/engine/modules/features/selectors"
import * as entity from "src/engine/modules/entity"
import collection from "src/hocs/collection"
import withRsqlQuery from "src/hocs/withRsqlQuery"

// Функция для настройки отображения колонок таблицы в зависимости от features
const filterColumnsByFeatures = (column, state) => {
  let filterColumns = column || []
  // check event status
  if (!selectStatusAvailable(state)) {
    filterColumns = filterColumns.filter(elem => elem.accessor !== `statusName`)
  }
  if (!selectPlanTagsAvailable(state)) {
    filterColumns = filterColumns.filter(elem => elem.accessor !== `tags`)
  }
  return filterColumns
}

export default ({
  to = `entities`,
  model,
  rewire = identity,
  config,
  ITEM_FORM_NAME = uuid4(),
  baseUri,
  columns: userColumns,
  shouldHideDeleted = () => false,
}) => {
  // Validate
  warning(isString(to), `entityList.to required`)
  warning(isObjectLike(model), `entityList.model required`)
  warning(
    !config || isObjectLike(config),
    `entityList.config expects to be object or null`,
  )
  warning(
    !rewire || isFunction(rewire),
    `entityList.rewire expects to be a function or null`,
  )
  warning(isString(baseUri), `entityList.baseUri expects to be a string`)

  // @TODO: Remove me as soon as possible! Here we ensure model has no `cumulative` flag to don't break pagination
  const modelClone = cloneDeep(model)

  if (modelClone.collection) {
    modelClone.collection.cumulative = false
  }

  const hocs = rewire([
    withRsqlQuery,

    branch(
      shouldHideDeleted,
      withPropsOnChange([`query`], ({ query }) => ({
        query: {
          ...query,
          query: `${query.query ? `${query.query};` : ``}deleteDate==null`,
        },
      })),
    ),

    collection({
      engine: entity,
      to,
      model: modelClone,
      controlledByQuery: true,
      ...collection,
    }),

    // Connect
    connect(null, (dispatch, props) => {
      const {
        queryParams,
        queryApi,
        model: { name },
        entities: { data },
      } = props
      const withTabs = name === `plan` || name === `planType`
      const searchQuery = queryString.stringify(queryParams)
      const columns = isFunction(userColumns)
        ? userColumns(props)
        : userColumns || []
      const filterColumns = filterColumnsByFeatures(
        columns,
        get(props, `state`),
      )
      return {
        submitForm: () => dispatch(submit(ITEM_FORM_NAME)),
        /* eslint consistent-return: 0, no-restricted-globals: 0, no-alert: 0 */
        resetForm: () => {
          queryApi.push(baseUri)
        },
        /* eslint-enable */
        newItem: () =>
          queryApi.push(`${baseUri}/new${withTabs ? `/main` : ``}`),

        searchQuery,
        dispatch,
        columns: filterColumns,
        // Extract data to root layer
        data,
        baseUri,
      }
    }),
    withHandlers({
      onChange: ({ location: { pathname }, queryApi }) => page => {
        // add filters here
        queryApi.push(pathname, {
          page,
        })
      },
    }),
  ])

  return compose(...hocs)
}
